<ng-container *transloco="let t" >
  <p-card styleClass="mb-3 openingHours-card" *ngFor="let day of days; index as i">
    <div class="flex justify-content-between align-items-center">
      <div class="flex">
        <div class="m-auto">
          <span class="material-icons text-indigo-500" aria-hidden="true">
            watch_later
          </span>
        </div>
        <div class="m-auto ml-3">
          <p class="m-0 p-0 font-semibold uppercase">{{ day }}</p>
          <ng-container *ngIf="openingHours[i] != 'Chiuso' && openingHours[i][0] != null">
            <p *ngIf="openingHours[i].length == 1" class="m-0 p-0">{{ openingHours[i] }}</p>
            <p *ngIf="openingHours[i].includes(null)" class="m-0 p-0">{{ openingHours[i][0] + ' - ' + openingHours[i][1]}}
            </p>
            <p *ngIf="!openingHours[i].includes(null) && openingHours[i].length != 1" class="m-0 p-0">{{ openingHours[i][0] + ' - ' + openingHours[i][1] }}
              <br> {{ openingHours[i][2] + ' - ' + openingHours[i][3]}}</p>
          </ng-container>
        </div>
      </div>
      <div class="flex align-items-center flex-column"
        [ngClass]="{'text-open-color': openingHours[i] != 'Chiuso' && openingHours[i][0] != null, 'text-close-color': openingHours[i] == 'Chiuso' || openingHours[i][0] == null}">
        <span class="material-icons" aria-hidden="true">
          {{ openingHours[i] != 'Chiuso' && openingHours[i][0] != null ? 'check_circle' : 'cancel' }}
        </span>
        <span>
          {{ openingHours[i] != 'Chiuso' && openingHours[i][0] != null ? t('location_open') : t('location_closed')}}
        </span>
      </div>
    </div>
  </p-card>
</ng-container>